// socketClient.js
import { io } from "socket.io-client";

// Utilise l'URL de ton backend depuis le fichier .env
const backendURL = process.env.REACT_APP_API_URL || "http://localhost:3312";

// Initialise une instance partagée de Socket.IO
const socket = io(backendURL, {
  transports: ["websocket"],
});

export default socket;
